"use strict";
exports.__esModule = true;
exports.SIZES = exports.TH_COLORS = exports.COLORS = void 0;
exports.COLORS = {
    primary: 'bg-primary-100 border-primary group-hover:bg-transparent',
    secondary: 'bg-secondary-100 border-secondary group-hover:bg-transparent',
    danger: 'bg-danger-100 border-danger group-hover:bg-transparent',
    warning: 'bg-warning-100 border-warning group-hover:bg-transparent',
    control: 'bg-control-100 border-control group-hover:bg-transparent',
    tertiary: 'bg-tertiary-100 border-tertiary group-hover:bg-transparent',
    success: 'bg-success-100 border-success group-hover:bg-transparent',
    info: 'bg-info-100 border-info group-hover:bg-transparent',
    inherit: 'bg-inherit border-inherit',
    slate: 'bg-slate-100 border-slate-500 group-hover:bg-transparent',
    zinc: 'bg-zinc-100 border-zinc-500 group-hover:bg-transparent',
    neutral: 'bg-neutral-100 border-neutral-500 group-hover:bg-transparent',
    stone: 'bg-stone-100 border-stone-500 group-hover:bg-transparent',
    red: 'bg-red-100 border-red-500 group-hover:bg-transparent',
    orange: 'bg-orange-100 border-orange-500 group-hover:bg-transparent',
    amber: 'bg-amber-100 border-amber-500 group-hover:bg-transparent',
    yellow: 'bg-yellow-100 border-yellow-500 group-hover:bg-transparent',
    lime: 'bg-lime-100 border-lime-500 group-hover:bg-transparent',
    green: 'bg-green-100 border-green-500 group-hover:bg-transparent',
    emerald: 'bg-emerald-100 border-emerald-500 group-hover:bg-transparent',
    teal: 'bg-teal-100 border-teal-500 group-hover:bg-transparent',
    cyan: 'bg-cyan-100 border-cyan-500 group-hover:bg-transparent',
    sky: 'bg-sky-100 border-sky-500 group-hover:bg-transparent',
    blue: 'bg-blue-100 border-blue-500 group-hover:bg-transparent',
    indigo: 'bg-indigo-100 border-indigo-500 group-hover:bg-transparent',
    violet: 'bg-violet-100 border-violet-500 group-hover:bg-transparent',
    purple: 'bg-purple-100 border-purple-500 group-hover:bg-transparent',
    fuchsia: 'bg-fuchsia-100 border-fuchsia-500 group-hover:bg-transparent',
    pink: 'bg-pink-100 border-pink-500 group-hover:bg-transparent',
    rose: 'bg-rose-100 border-rose-500 group-hover:bg-transparent'
};
exports.TH_COLORS = {
    primary: 'bg-primary-light border-primary focus:!bg-primary-600 hover:!bg-primary-600',
    secondary: 'bg-secondary-light border-secondary focus:!bg-secondary-600 hover:!bg-secondary-600',
    danger: 'bg-danger-light border-danger focus:!bg-danger-600 hover:!bg-danger-600',
    warning: 'bg-warning-light border-warning focus:!bg-warning-600 hover:!bg-warning-600',
    control: 'bg-control-light border-control focus:!bg-control-600 hover:!bg-control-600',
    tertiary: 'bg-tertiary-light border-tertiary focus:!bg-tertiary-600 hover:!bg-tertiary-600',
    success: 'bg-success-light border-success focus:!bg-success-600 hover:!bg-success-600',
    info: 'bg-info-light border-info focus:!bg-info-600 hover:!bg-info-600',
    inherit: 'bg-inherit border-inherit',
    slate: 'bg-slate-300 border-slate-500 focus:!bg-slate-600 hover:!bg-slate-600',
    zinc: 'bg-zinc-300 border-zinc-500 focus:!bg-zinc-600 hover:!bg-zinc-600',
    neutral: 'bg-neutral-300 border-neutral-500 focus:!bg-neutral-600 hover:!bg-neutral-600',
    stone: 'bg-stone-300 border-stone-500 focus:!bg-stone-600 hover:!bg-stone-600',
    red: 'bg-red-300 border-red-500 focus:!bg-red-600 hover:!bg-red-600',
    orange: 'bg-orange-300 border-orange-500 focus:!bg-orange-600 hover:!bg-orange-600',
    amber: 'bg-amber-300 border-amber-500 focus:!bg-amber-600 hover:!bg-amber-600',
    yellow: 'bg-yellow-300 border-yellow-500 focus:!bg-yellow-600 hover:!bg-yellow-600',
    lime: 'bg-lime-300 border-lime-500 focus:!bg-lime-600 hover:!bg-lime-600',
    green: 'bg-green-300 border-green-500 focus:!bg-green-600 hover:!bg-green-600',
    emerald: 'bg-emerald-300 border-emerald-500 focus:!bg-emerald-600 hover:!bg-emerald-600',
    teal: 'bg-teal-300 border-teal-500 focus:!bg-teal-600 hover:!bg-teal-600',
    cyan: 'bg-cyan-300 border-cyan-500 focus:!bg-cyan-600 hover:!bg-cyan-600',
    sky: 'bg-sky-300 border-sky-500 focus:!bg-sky-600 hover:!bg-sky-600',
    blue: 'bg-blue-300 border-blue-500 focus:!bg-blue-600 hover:!bg-blue-600',
    indigo: 'bg-indigo-300 border-indigo-500 focus:!bg-indigo-600 hover:!bg-indigo-600',
    violet: 'bg-violet-300 border-violet-500 focus:!bg-violet-600 hover:!bg-violet-600',
    purple: 'bg-purple-300 border-purple-500 focus:!bg-purple-600 hover:!bg-purple-600',
    fuchsia: 'bg-fuchsia-300 border-fuchsia-500 focus:!bg-fuchsia-600 hover:!bg-fuchsia-600',
    pink: 'bg-pink-300 border-pink-500 focus:!bg-pink-600 hover:!bg-pink-600',
    rose: 'bg-rose-300 border-rose-500 focus:!bg-rose-600 hover:!bg-rose-600'
};
exports.SIZES = {
    large: 'h-20',
    medium: 'h-15',
    small: 'h-10'
};
//# sourceMappingURL=table-cell.style.js.map